import type { Country, Language } from '../graphql/codegen';

import { useMemo } from 'react';

import { useAppContext } from '../context/static/AppContext';
import { useCountriesQuery } from '../graphql/codegen';
import type { Option } from '~/components/shared/core/form';

type SupportedLanguages = {
  [key: string]: (Language | undefined | null)[];
};

type ReturnType = {
  countries: (Country | null)[];
  activeOptions: Option[];
  supportedLanguages: SupportedLanguages;
};

export const useAvailableCountries = (): ReturnType => {
  const { locale, siteType } = useAppContext();

  const { data } = useCountriesQuery({
    variables: {
      siteType,
      locale,
    },
    ssr: false,
  });

  const countries = useMemo<(Country | null)[]>(() => data?.countries ?? [], [data?.countries]);

  const activeOptions = useMemo<Option[]>(
    () =>
      countries.map(countryInfo => ({
        label: countryInfo?.name || '',
        value: countryInfo?.isocode?.toLowerCase() || '',
      })),
    [countries]
  );

  const supportedLanguages = useMemo<SupportedLanguages>(() => {
    const result: SupportedLanguages = {};

    countries.forEach(countryInfo => {
      const key = countryInfo?.isocode?.toLowerCase() || '';

      result[key] = countryInfo?.supportedLanguages ?? [];
    });

    return result;
  }, [countries]);

  return {
    countries,
    activeOptions,
    supportedLanguages,
  };
};
